<form #visitForm="ngForm" (ngSubmit)="onSubmit(visitForm.form)">
    @for (selected of visit.selectedFeedbacks; track selected.feedbackCd;let i=$index){
    <div class="base-container column-group lone">
        <label for="feedback">Feedback category{{($first)?'*':''}}</label>
        <mat-form-field class="select-mat-form-field dp-input-control lone select"
            [class.dp-input-error]="fdback.touched&&fdback.invalid&&$first">
            <mat-select (selectionChange)="visitEmitter.emit(visit)" [required]="$first"
                placeholder="Select feedback from given list" [name]="selected.feedbackCd.toString()"
                [ngModel]="selected.feedbackMsg" #fdback="ngModel"><!---->
                @for (feedback of visit.feedbackList; track feedback.feedbackCd; let j=$index) {
                <mat-option (click)="visit.selectedFeedbacks[i]=feedback" #option
                    [value]="feedback.feedbackMsg"><!--[disabled]="isFeedbackDisabled(j)"-->
                    {{feedback.feedbackMsg}}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        @if(!$first||($first&&visit.selectedFeedbacks[0]&&visit.selectedFeedbacks[0].feedbackMsg)){
        <button type="button" class="dp-tertiary-btn" (click)="removeFeedback(i,$count)">
            Remove feedback
        </button>
        }
        @if($last&&$count<3){ <button type="button" class="dp-secondary-btn custom"
            (click)="visit.selectedFeedbacks.push({feedbackCd:-1,feedbackMsg:''})">
            <i></i>
            Add more
            </button>
            }
            @if(fdback.touched&&fdback.invalid&&$last){
            <small class="error-message feedback-error">The first feedback is required. Remove blank feedback fields if
                present.</small>
            }
    </div>
    }
    @if(!utilService.isMobileDevice()){
    <br>
    }
    <div class="base-container column-group lone" [class.lone]="rowData.visit_count<3">
        <label for="contact">Contact Info.*</label>
        <input type="text" id="contact" class="dp-input-control" placeholder="Enter contact number" required
            minlength="10" maxlength="10" name="contact" [(ngModel)]="memDetails.contact" #cnct="ngModel"
            (input)="detailsEmitter.emit(memDetails)" [class.dp-input-error]="cnct.touched&&cnct.invalid"
            (keydown)="onContactKeydown($event)">
        @if(cnct.touched&&cnct.invalid){
        <small class="error-message">Contact is required.</small>
        }
    </div>
    <div class="base-container column-group lone">
        <label for="comments">Add comments*</label>
        <span class="counter">{{count.value.length}}/120</span>
        <textarea #count id="comments" class="dp-input-control lone fixed" maxlength="120" placeholder="Enter notes"
            required name="comment" [(ngModel)]="visit.comment" #cmnt="ngModel" (input)="visitEmitter.emit(visit)"
            [class.dp-input-error]="cmnt.touched&&cmnt.invalid">
        </textarea>
        @if(cmnt.touched&&cmnt.invalid){
        <small class="error-message">Comments are required.</small>
        }
    </div>
    @for(count of counter;track count; let i=$index){
    <div class="base-container column-group lone">
        <label for="worker">Accompanied by</label>
        <input type="text" class="dp-input-control lone" placeholder="Enter worker's name" style="font-weight: 500"
            [matAutocomplete]="auto" [name]="i.toString()" [ngModel]="setWorkerField(i)" #worker="ngModel"
            (ngModelChange)="workerName=$event" (focus)="workers=[]" (input)="wrkrPointer=i;searchWorker()"
            [class.dp-input-error]="(worker.invalid||wrkrValidnErr[i]||workerError[i])&&worker.touched">
        <mat-autocomplete #auto="matAutocomplete">
            @for (wrkr of workers; track wrkr.ritwikCode; let j=$index) {
            <mat-option [value]="wrkr.fullName"
                (click)="visit.selectedWorkers[wrkrPointer]=wrkr;workerError[i];wrkrValidnErr[i]=false;visitEmitter.emit(visit)">
                {{wrkr.fullName+' '}}
                <span class="sub-text">
                    {{(wrkr.workerType)?'('+wrkr.workerType+') ':''}}
                    {{(wrkr.state)?wrkr.state:''}}
                    {{(wrkr.district)?', '+wrkr.district:''}}
                </span>
                <div>
                <span class="sub-text">
                    {{(wrkr.address) ? wrkr.address : ''}}
                </span>
                </div>
            </mat-option>
            }
            @empty{
            <mat-option value="">{{workerError[i]}}</mat-option>
            }
        </mat-autocomplete>
        @if(!$first||($first&&visit.selectedWorkers[0]&&visit.selectedWorkers[0].fullName)){
        <button type="button" class="dp-tertiary-btn" (click)="removeWorker(i)">
            Remove worker
        </button>
        }
        @if(workerError[i]&&!wrkrValidnErr[i]){
        <small class="error-message worker-error" [class.error-btn-present]="$last&&$count<3&&$count!==1"
            [class.error-top-1]="$first&&$last" [class.error-top-2]="$first&&!$last">
            {{workerError[i]}}
        </small>
        }
        @if(wrkrValidnErr[i]){
        <small class="error-message worker-error" [class.error-btn-present]="$last&&$count<3&&$count!==1"
            [class.error-top-1]="$first&&$last" [class.error-top-2]="$first&&!$last">
            Enter valid worker name and/or select from list.
        </small>
        }

        @if($last&&$count<3){ <button type="button" class="dp-secondary-btn custom" (click)="addWorker()">
            <i></i>
            Add more
            </button>
            }
    </div>
    }

    @if(flow==='visit'){
    @if (memDetails.familyCode) {
    <div class="base-container column-group lone">
        <label for="familyCode">Family Code</label>
        <input type="text" id="familyCode" class="dp-input-control lone" readonly
            placeholder="Enter 12 digit family code" minlength="12" maxlength="12" name="familyCode"
            [(ngModel)]="memDetails.familyCode" #fc="ngModel" [class.dp-input-error]="fc.touched&&fc.invalid">
        @if(fc.touched&&fc.invalid){
        <small class="error-message">Please provide valid family code.</small>
        }
    </div>
    }
    <label class="lone">If dikshyarthi current address changed :</label>
    <div class="base-container row-group" [style]="(rowData.visit_count<3)?'flex-wrap: wrap':''">
        <div class="base-container column-group" [class.small]="rowData.visit_count<3&&!utilService.isMobileDevice()">
            <label for="pincode">PIN code</label>
            <input type="number" id="pincode" class="dp-input-control" min="100000" max="999999"
                placeholder="Enter pincode" (input)="searchPincode();pincodeError=''" name="pincode"
                [(ngModel)]="addressDetails.pincode" #pin="ngModel"
                [class.dp-input-error]="(pin.touched&&pin.invalid)||pincodeError" [readOnly]="addressDisabled()">
            @if(pin.touched&&pin.invalid){
            <small class="error-message">Enter valid pincode.</small>
            }
            @if(pincodeError){
            <small class="error-message">{{pincodeError}}</small>
            }
        </div>
        <div class="base-container column-group" [class.small]="rowData.visit_count<3&&!utilService.isMobileDevice()">
            <label for="state">State</label>
            @if(addressDetails.stateList.length>1){
            <mat-form-field class="select-mat-form-field dp-input-control select">
                <mat-select id="state" placeholder="Select state"
                    (selectionChange)="addressEmitter.emit(addressDetails)" name="state"
                    [(ngModel)]="addressDetails.state" #st="ngModel" required [inert]="addressDisabled()">
                    @for (state of addressDetails.stateList; track state) {
                    <mat-option [value]="state">{{state}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @if(st.touched&&st.invalid){
            <small class="error-message">Please select an option.</small>
            }
            }
            @else{
            <input type="text" id="state" class="dp-input-control" readonly placeholder="Enter pincode first"
                (input)="addressEmitter.emit(addressDetails)" name="state" [(ngModel)]="addressDetails.state"
                #st="ngModel">
            }
        </div>
        <div class="base-container column-group" [class.small]="rowData.visit_count<3&&!utilService.isMobileDevice()">
            <label for="district">District</label>
            @if(addressDetails.districtList.length>1){
            <mat-form-field class="select-mat-form-field dp-input-control select">
                <mat-select id="district" placeholder="Select district"
                    (selectionChange)="addressEmitter.emit(addressDetails)" name="district"
                    [(ngModel)]="addressDetails.district" #dst="ngModel" required [inert]="addressDisabled()">
                    @for (district of addressDetails.districtList; track district) {
                    <mat-option [value]="district">{{district}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @if(dst.touched&&dst.invalid){
            <small class="error-message">Please select an option.</small>
            }
            }
            @else{
            <input type="text" id="district" class="dp-input-control" readonly placeholder="Enter pincode first"
                (input)="addressEmitter.emit(addressDetails)" name="district" [(ngModel)]="addressDetails.district"
                #dst="ngModel">
            }
        </div>
    </div>
    <div class="base-container column-group lone">
        <label for="address">Current Address</label>
        <textarea id="address" class="dp-input-control lone fixed" maxlength="120"
            (input)="addressEmitter.emit(addressDetails)" placeholder="Enter detailed address of dikshyarthi."
            pattern="[A-Za-z0-9.; ,/&()-]+" (keydown)="onAddressKeydown($event)" minlength="10"
            [readOnly]="addressDisabled()" name="address" [(ngModel)]="addressDetails.address" #adr="ngModel"
            [class.dp-input-error]="adr.touched&&adr.invalid">
        </textarea>
        @if(adr.touched&&adr.invalid){
        <small class="error-message">Provide valid address of atleast 10 characters. (' . ( ) / & , ; - ' special
            characters allowed).</small>
        }
    </div>
    <div class="base-container column-group lone mob-gap">
        <label for="landmark">Current Landmark</label>
        <input type="text" id="landmark" class="dp-input-control lone" (input)="addressEmitter.emit(addressDetails)"
            placeholder="Provide a suitable landmark for future convenience." (keydown)="onLandmarkKeydown($event)"
            [readOnly]="addressDisabled()" name="landmark" [(ngModel)]="addressDetails.landmark" #lnd="ngModel"
            [class.dp-input-error]="lnd.touched&&lnd.invalid">
        @if(lnd.touched&&lnd.invalid){
        <small class="error-message">Please provide a valid landmark.</small>
        }
    </div>
    }
</form>
<span class="proceed">
    <button class="dp-secondary-btn" (click)="(flow==='visit')?step.emit(0):step.emit(2)">Go back to previous</button>
    <button class="dp-primary-btn" (click)="choice='visit';visitForm.ngSubmit.emit()">{{(visited)?'Update':'Add'}} your
        visit</button>
    @if(flow==='update'){
    <button class="dp-primary-btn" (click)="choice='update';visitForm.ngSubmit.emit()">Update member and
        {{(visited)?'update':'add'}} visit</button>
    }
</span>